import type { MarketExceptionType } from '../../MarketExceptionTypes'

export const Common: MarketExceptionType = {
  hasNativeCreditCard: false,
  hasStoreCredit: false,
  marketoSmsOptIn: false,
  signUpReCaptcha: false,
  showPasswordRequirements: false,
  shippingMethodRestrictions: [],
  shippingMethodsHidden: [],
  subscriptionPaymentWithOrdersCallOnly: false,
  signupPrivacyPolicy: {
    enabled: false,
    required: false,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: false,
    required: false,
  },
  subscriptionManager: {},
  checkoutTermsAndConditionsStatement: false,
  currencyCode: 'USD',
  creditCardProvidersSupported: [],
  selectableShippingCountries: [],
  poboxRestricted: false,
  isPickupMarket: false,
  hasAddressRegion: false,
  allowShippingToExternalCountries: false,
  supportsStoreCredit: false,
  provinceOrderCalc: false,
  isCashMarket: false,
  isWorldPay3DS: false,
  bankName: '',
  applePayOTP: false,
  applePaySubscriptions: false,
  hasAddressValidation: false,
  hasPaypal: false,
  hasPaypal3DS: false,
  skuPricingOverrides: [],
  hasShipByDate: false,
  nfrAllowedMarkets: [],
  availableNfrMarkets: [],
  hasIPay88CreditCard3DS: false,
  omitSubscriptionsAppWide: false,
  hasProductAvailability: false,
  restrictedPickupLocations: [],
  skuAvailabilityShippingMethod: 'Economy',
  defaultEconomyShippingMethod: 'Economy',
  allowSubscriptionPickup: false,
  hasGCash3DS: false,
  hasCMI3DS: false,
  hasBankWire: false,
  hasHsa: false,
  hasSubscriptionSchedule: false,
  disableMixedOrders: false,
  storeCreditEligibleCustomerTypes: [],
  reportIssueButton: {
    show: false,
    url: {},
  },
  tax: {
    inclusive: false,
  },
  isHostedPayments: false,
  isUlabsAvailable: false,
  rtlLanguages: {
    enabled: false,
  },
  addressFormConfig: [
    { field: 'firstName', required: true },
    { field: 'lastName', required: true },
    { field: 'country', required: true },
    { field: 'empty', required: true }, // Adding empty helps to get the desired grid layout
    { field: 'address1', required: true },
    { field: 'address2', required: false },
    { field: 'city', required: true },
    { field: 'state', required: true },
    { field: 'zip', required: true },
  ],
  hasPayPay: false,
  productOrder: null,
  addressDisplayOrder: {
    line1: [{ field: 'firstName' }, { field: 'lastName' }],
    line2: [{ field: 'address1' }],
    line3: [{ field: 'address2' }],
    line4: [
      { field: 'city', addComma: true },
      { field: 'state', addComma: true },
      { field: 'zip' },
      { field: 'country' },
    ],
  },
  quickLinks: null,
}
